import {
  EVENT_CALL_STARTED,
  EventCallStartedPayload,
} from '@weblite/ts-action/media-proxy'
import { getRoom } from '$logic/room'
import { CallWappPanel } from '$logic/wapp-panels'
import { closePvCallManager } from '$logic/router'
import { serverSub } from '$func/subscription'
import { callStorage } from './storage'
import { dateWithOffset } from '$setup/time-offset'

serverSub.subscribe(
  EVENT_CALL_STARTED,
  async ({ roomId, callType, token }: EventCallStartedPayload) => {
    console.log('started ', { roomId, callType, token })
    const { roomId: callRoomId } = callStorage.get()
    if (roomId !== callRoomId) return
    if (callType === 'call') {
      callStorage.set({ state: 'ongoing', joinedAt: new Date().getTime() })
      closePvCallManager()

      const { call } = await getRoom(roomId)
      CallWappPanel.openCall(callType, token, {
        startedAt: call?.startedAt ?? dateWithOffset(),
      })
    }
  },
)
